import { createContext, useContext } from 'react'
import { DocletHostMedia } from '../../../doclets/types'

interface HostMediaFields {
  id?: string | null
  url?: string | null
  transcode?: string | null
}

// The page's view of a host media record; null without an id
export const toDocletHostMedia = (
  media: HostMediaFields | null | undefined
): DocletHostMedia | null =>
  media?.id
    ? {
        id: media.id,
        url: media.url ?? null,
        transcode: media.transcode ?? 'unknown'
      }
    : null

/**
 * The page plays host media records the doclet query loaded. While the
 * builder is open, Media editors report newer ones here (an upload, a pasted
 * link, Vimeo finishing), so the canvas plays them straight away.
 */
export const RecordHostMediaContext = createContext<
  (media: HostMediaFields | null | undefined) => void
>(() => {})

export const useRecordHostMedia = () => useContext(RecordHostMediaContext)
